<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				<span class="text-wrap" v-html="subtitle"></span>
			</v-card-subtitle>
		</v-card-item>

		<v-card-item v-for="(template, index) in templates" :key="index">
			<v-card-title :class="titleClass">
				<v-btn
					class="text-none my-4 text-decoration-underline" height="auto"
					variant="text"
					@click.stop="onDowdload(template)"
				>
					<span class="text-wrap">
						{{ template.name }}
					</span>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<span v-html="template.description"></span>
			</v-card-text>
		</v-card-item>

		<z-photo ref="photo" 
			v-model="item.files"
			:required="item.required"
			:min="item.min"
			:max="item.max"
			:visible="visible"
			:changed="item.changed"
			hide-control
			@change="item.changed=true"
		></z-photo>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/main'
import zPhoto from '@/components/banners/Photo4'

export default {
	name: 'Component::EventNotification',
	mixins: [mixin],
	components: { zPhoto },
	computed: {
		templates() {
			//console.log(this.$options.name, 'files', 'item', this.item)

			return this.item?.templates ? this.item.templates : []
		},
	},
	methods: {
		validate() {
			return this.$refs.photo?.validate()
		},

		onDowdload(item) {
			//console.log(this.$options.name, 'onDowdload', 'path', item.path)
			
			var that = this
			axios.get(item.path, { responseType: 'blob' }).then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' })
				const link = document.createElement('a')
				link.href = URL.createObjectURL(blob)
				link.download = item.name
				link.click()
				URL.revokeObjectURL(link.href)
			}).catch(console.error)
		},
	},
}
</script>
